<template>
	<div v-loading.fullscreen.lock="config.loading.save" element-loading-text="Aguarde um momento...">
		<ed-modal 
			:title="'Enviar Email de Teste :: Conta '+(this.parent ? this.parent.formData.email : '')" 
			:modal="showFormEdit" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="60%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="formData" :config="config" :response="response" :itens="exameItems">
					<div slot="form-footer"></div>
				</ed-form>
			</div>
		</ed-modal>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import EdModal from 'common/modal';
	import FormItems  from './_form/email-teste';

  	export default {
  		name:"exame-editar",
  		components: {EdForm,EdModal},
		mixins:[Rest],
		props:{
            parent:{
                type: Object,
                default: null
			},
			showForm:{
				type: Boolean,
                default: false
			}
        },
		watch: {
			'parent.formData.id'(){
			},
			showForm(){
				this.showFormEdit = !this.showFormEdit;
				this.init();
			},
		},
  		data () {
		   	return {
				config:{
					hidden:{
					},
					click:{
					},
					loading:{
						save:false,
						content:false,
					},
					list:{
					}
				},
		   		formData:{
					id:0,
		   			email:null,
		   		},
				response:{},
				exameItems:[],
				showFormEdit:false,
			}
		},

		mounted() {
			this.exameItems = FormItems;
		},

		methods: {

			init(){
			},

			salvar(){

				this.response = {};
				this.config.loading.save = true;
				
				this.formData.id = this.parent.formData.id;

				this.post('/conta-email/testar',this.formData).then((result)=>{
					result = result[0];

					this.config.loading.save = false;

					if(result.status == 200){
						this.showFormEdit = !this.showFormEdit;
						this.edAlert('Email enviado com sucesso');
					}
				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// teste.vue?768649de